import React, { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { fetchClientSectionTableAndFilterSchema } from "model/ClientSectionModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const ClientSectionContext = createContext();

export const ClientSectionProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clientSectionContextData, setClientSectionContextData] = useState();

  const fetchClientSectionContextData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchMetadataSchema("metadata:clientSection", () =>
        fetchClientSectionTableAndFilterSchema([])
      );
      if (response?.success) {
        setClientSectionContextData(response?.data);
      } else {
        setError(response?.message || "Unable to fetch client metadata");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ClientSectionContext.Provider
      value={{
        fetchClientSectionContextData,
        clientSectionContextData,
        loading,
        error,
      }}
    >
      {children}
    </ClientSectionContext.Provider>
  );
};

export const useClientSectionContext = () => useContext(ClientSectionContext);
